module.exports = __webpack_public_path__ + "frontend/images/homepage/slider/card.jpg?49f0854fb8f89d77f3255763a4fb4dc5";